(ns core.util.normalize
  (:require [clojure.string :as str]
            [core.util.string :as str-util])
  #?(:clj (:import [java.text Normalizer Normalizer$Form])))


#?(:cljs
   ;; Seems that the Unicode property escapes like Diacritic cannot be directly used in CLJS pattern
   (def js-pattern (js/RegExp. "\\p{Diacritic}+" "gu")))


(defn de-accent
  "Replaces accent characters with base letters"
  [s]
  (when s
    #?(:clj  (-> (Normalizer/normalize ^String s Normalizer$Form/NFD)
                 (str/replace #"\p{InCombiningDiacriticalMarks}+" ""))
       :cljs (-> (.normalize s "NFD")
                 (str/replace js-pattern "")))))


(def keyword-forbidden-pattern
  #"[^a-zA-Z0-9\*\+!\-_'\?<>=]")

(def starts-with-digit-pattern
  #"^[0-9].*")

(def filename-forbidden-pattern
  "Allow everything except characters that Windows prohibits - that seems to
  be a subset of what osx and linux forbid."
  #"[/\?<>\\\:\*\|\"\u0000-\u001f]")

(def gcs-object-key-forbidden-pattern
  "Characters that are known to break GCS tooling or XML listings.
   Keep `/` allowed because object keys often use it as a path separator."
  #"[\u0000-\u001F\u007F-\u0084\u0086-\u009F#\[\]\*\?:\"<>|]")


(defn- sanitize-string
  "Replaces all non-ascii chars and others that are not strictly allowed in Clojure symbols or keywords with -."
  [forbidden-pattern source-string]
  (when-let [de-accented (de-accent source-string)]
    (str/replace de-accented forbidden-pattern "-")))


(defn keyword-safe
  "Replaces all non-ascii chars and others that are not strictly allowed in Clojure symbols or keywords with -.
  Appends kw- if the string starts with a number.
  See documentation at https://clojure.org/reference/reader"
  [source-text]
  ;; For some reason :a/1 is not accepted as a keyword, but :1 is.
  (let [sanitized (sanitize-string keyword-forbidden-pattern source-text)]
    (if (re-matches starts-with-digit-pattern sanitized)
      (str "kw-" sanitized)
      sanitized)))

(def windows-filename-max-length 255)

(defn- last-n [n ^String s]
  (when s
    (apply str (take-last n s))))

(defn truncate-filename [filename]
  (last-n windows-filename-max-length filename))

(defn filename-safe
  "Make an acceptable file name out of an arbitrary string"
  [source-text]
  (-> (sanitize-string filename-forbidden-pattern source-text)
      truncate-filename))

(defn gcs-object-key-safe
  "Sanitizes a GCS object key while preserving path separators.

   Replaces characters that are known to break GCS tooling or XML listings
   with `-`, and neutralizes `.` / `..` path segments so downloads cannot be
   interpreted as relative paths by client tools."
  [source-text]
  (some-> source-text
          (str/replace gcs-object-key-forbidden-pattern "-")
          (str/split #"/" -1)
          (#(map (fn [segment]
                   (case segment
                     "." "-"
                     ".." "--"
                     segment))
                 %))
          (#(str/join "/" %))))

(defn identifier-safe
  "Replaces all non-ascii chars, spaces and other \"difficult\" characters with  - for use in identifiers.
   Allows fully numerics strings. Use `keyword-safe` to produce a string for keyword use."
  [source-string]
  (sanitize-string keyword-forbidden-pattern source-string))

(defn keyword-from-name [source-text]
  (when source-text
    (let [trimmed (str/trim source-text)]
      (when-not (str/blank? trimmed)
        (-> trimmed
            str/lower-case
            keyword-safe
            keyword)))))

(defn canonicalize-email [email]
  (some-> email str/trim str/lower-case))

(defn hyphenated-string
  "Normalizes string to a hyphenated string.
   - Removes accents (é → e)
   - Converts to lowercase
   - Replaces non-alphanumeric characters with hyphens
   - Collapses consecutive hyphens
   - Trims leading/trailing hyphens

   Example: 'Brighton Township, PA' → 'brighton-township-pa'"
  [name]
  (some->> name
           str/trim
           str/lower-case
           (sanitize-string #"[^a-z0-9]+")
           str-util/blank->nil))
